//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { Activity, Enums } from "../../models/common"

import { TemplateHelper, ConfigHelper, LocalizationHelper } from "../../helpers"
import { SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListService } from "../system"
import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"

//#region Public Types

export const TASK_CONTEXT_MENU_SERVICE_NAME = 'taskContextMenuService'
export const TASK_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'taskContextMenuServiceProvider'

export type IdTaskGridContextMenuOptions = {
    idReferenceTypes?: number[]
    onEdit?: (e: any) => void
    showStatusChangePopup?: () => void
}

//#endregion

export class TaskContextMenuService {

    // #region Ctor

    public constructor(
        private readonly systemContextListService: SystemContextListService,
        private readonly userSessionService: UserSessionService
    ) { }

    // #endregion


    // #region Public Methods

    public getContextMenuItems(options: IdTaskGridContextMenuOptions): any[] {
        const items: { beginGroup?: boolean, template: string, onItemClick: (args: any) => void }[] = []

        if (options == null) {
            return items
        }

        if (options.onEdit != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_EDIT)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSessionService),

                onItemClick: (args: any) => {
                    options.onEdit(args)
                },
            })
        }

        if (options.idReferenceTypes != null) {

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationModule)) {
                items.push({
                    beginGroup: true,
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowLocations), ConfigHelper.Icon.LOCATIONS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdLocation, options.idReferenceTypes, Enums.ReferenceType.IdTask)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowMeters), ConfigHelper.Icon.METERS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdMeter, options.idReferenceTypes, Enums.ReferenceType.IdTask)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DeviceModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowDevices), ConfigHelper.Icon.DEVICES, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.SerialNbr, options.idReferenceTypes, Enums.ReferenceType.IdTask)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ISSUE_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.ISSUE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueMoodule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowIssues), ConfigHelper.Icon.ISSUES, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdIssue, options.idReferenceTypes, Enums.ReferenceType.IdTask)
                    }
                })
            }
        }

        if (
            options.showStatusChangePopup != null
            && this.userSessionService.getLoggedOperator().hasPermission(Activity.ALLOWED_TASK_STATUS_CHANGE)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskStatus)
        ) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ChangeTaskStatus), ConfigHelper.Icon.SWAP_VERT, this.userSessionService),
                onItemClick: () => {
                    options.showStatusChangePopup()
                },
            })
        }

        return items
    }

    // #endregion
}

export class TaskContextMenuServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [SYSTEM_CONTEXT_LIST_SERVICE_NAME, USER_SESSION_SERVICE_NAME, function (systemContextListService: SystemContextListService, userSessionService: UserSessionService) {
        return new TaskContextMenuService(systemContextListService, userSessionService)
    }]

    //#endregion
} 
